import { configureStore } from '@reduxjs/toolkit'
import { authApi } from './api/authApi'
import { dashboardApi } from './api/dashboardApi'
import { usersApi } from './api/usersApi'
import { billingApi } from './api/billingApi'
import { organizationsApi } from './api/organizationsApi'
import { projectsApi } from './api/projectsApi'
import { membersApi } from './api/membersApi'
import { invitationsApi } from './api/invitationsApi'
import { discountCodesApi } from './api/discountCodesApi'
import { notificationsApi } from './api/notificationsApi'
import { educationApi } from './api/educationApi'
import { schoolAdminApi } from './api/schoolAdminApi'
import authReducer from './slices/authSlice'
import uiReducer from './slices/uiSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    ui: uiReducer,
    [authApi.reducerPath]: authApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [billingApi.reducerPath]: billingApi.reducer,
    [organizationsApi.reducerPath]: organizationsApi.reducer,
    [projectsApi.reducerPath]: projectsApi.reducer,
    [membersApi.reducerPath]: membersApi.reducer,
    [invitationsApi.reducerPath]: invitationsApi.reducer,
    [discountCodesApi.reducerPath]: discountCodesApi.reducer,
    [notificationsApi.reducerPath]: notificationsApi.reducer,
    [educationApi.reducerPath]: educationApi.reducer,
    [schoolAdminApi.reducerPath]: schoolAdminApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      dashboardApi.middleware,
      usersApi.middleware,
      billingApi.middleware,
      organizationsApi.middleware,
      projectsApi.middleware,
      membersApi.middleware,
      invitationsApi.middleware,
      discountCodesApi.middleware,
      notificationsApi.middleware,
      educationApi.middleware,
      schoolAdminApi.middleware
    ),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
